import Vue from 'vue'
import date from '@tencent/vft-common/date'
import { normalize } from '@tencent/vft-common/url'

Vue.filter('date', function (v, format) {
  return date.format(v, format)
})
Vue.filter('urlNormalize', function (v) {
  return normalize(v)
})
